$shm_hitalama_textarea $shm_textarea_code
	View $shm_hitalama_textarea_code
		text <= value
		row_numb* <= row_numb*
		sidebar_showed <= sidebar_showed
		highlight <= highlight
		syntax <= syntax $mol_syntax2
		value_click*? <=> value_click*? null

$shm_hitalama_textarea_code $shm_textarea_code_view
	Row*0 $shm_hitalama_textarea_code_line
		numb_showed <= sidebar_showed
		numb <= row_numb*
		theme <= row_theme*
		text <= row_text*
		syntax <= syntax
		uri_resolve* <= uri_resolve*
		value_click*? <=> value_click*? null
		highlight <= highlight

$shm_hitalama_textarea_code_line $shm_textarea_code_line
	value_click*? null
	Token_value* $shm_hitalama_textarea_code_token_value
		type <= token_type*
		haystack <= token_text*
		needle <= highlight
		click? <=> token_value_click*? null

$shm_hitalama_textarea_code_token_value $mol_text_code_token
	event *
		^
		click? <=> click? null
	attr *
		^
		role \link
		tabindex \0
